module.exports = __webpack_public_path__ + "img/album18_39.48a72273.jpg";